import React, { useImperativeHandle, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import Controls from './Controls';

interface LoadingModalPros {
    title: string;
}

export interface LoadingModalHandle {
    handleOpen: (e?: any) => void;
    showMessageSuccess: (e: string) => void;
    showMessageError: (e: string) => void;
}

const LoadingModal: React.ForwardRefRenderFunction<LoadingModalHandle, LoadingModalPros> = (props, ref) => {

    const { title } = props;

    const [open, setOpen] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState<string>("");
    const [messageError, setMessageError] = useState<string>("");

    useImperativeHandle(ref, () => {
        return {
            handleOpen,
            showMessageSuccess,
            showMessageError
        }
    })

    const handleOpen = () => {
        setOpen(true);
        setMessageSuccess("");
        setMessageError("");

    };

    const showMessageSuccess = (message: string) => {
        setMessageSuccess(message);
    };

    const showMessageError = (message: string) => {
        setMessageError(message);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <div>
            <Dialog
                open={open}
                fullWidth
                maxWidth="sm"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title"  >
                    <Typography variant="h6" align="center">{title}</Typography>
                </DialogTitle>
                <DialogContent>
                    {messageSuccess}
                    {messageError}
                    {
                        messageSuccess === "" && messageError === "" ?
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <CircularProgress />
                            </Box>
                            : <Typography></Typography>
                    }
                </DialogContent>
                <DialogActions>
                    {
                        messageSuccess !== "" || messageError !== "" ?
                            <Controls.Button text="Fechar" type="BlankNoBorder" onClick={handleClose} />
                            : null
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default React.forwardRef(LoadingModal)